// import React, { useState, useEffect, useContext } from "react";
// import {
//   User,
//   Phone,
//   Mail,
//   MapPin,
//   Shield,
//   Clock,
//   Hospital,
// } from "lucide-react";
// import Navbar from "../components/Navbar";
// import languageContext from "../context/language/languageContext";
// import API from "../api";
// import { useNavigate } from "react-router-dom";
  

// const DoctorProfile = () => {
//   const {
//     lang,
//     setSessionTimeout,
//     setAlert,
//     setMessage,
//   } = useContext(languageContext);

//   const [doctor, setDoctor] = useState(null);
//   const [subscription, setSubscription] = useState(null);
//   const navigate = useNavigate();


//   const getSubscription = async () => {
//   try {
//     const res = await API.post(
//       "/subscription",
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     setSubscription(res.data);
//   } catch (error) {
//     console.error("Subscription fetch failed", error);
//   }
// };

//   const getDoctorDetails = async () => {
//     const headersList = {
//       Accept: "*/*",
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//       "Content-Type": "application/json",
//     };

//     try {
//       const response = await API.post(
//         "/show_profile",
//         {},
//         { headers: headersList }
//       );

//       if (response.status === 200) {
//         setDoctor(response.data?.doctor_details || {});
//       }
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data.detail === "Token has expired"
//       ) {
//         setSessionTimeout(true);
//       } else {
//         console.error("Error Details:", error.message);
//         setAlert(true);
//         setMessage("Please try again later, something went wrong");
//       }
//     }
//   };

//   useEffect(() => {
//     getDoctorDetails();
//     getSubscription();
//   }, []);

//   return (
//     <div className="min-h-screen bg-gradient-to-tr from-blue-50 to-white">
//       <Navbar />

//       {/* Top margin after fixed Navbar */}
//       <div className="pt-24 px-4 pb-12 max-w-4xl mx-auto">
//         <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 space-y-6 border border-blue-100">
//           {!doctor ? (
//             <p className="text-center text-gray-500 text-lg">
//               Loading doctor details...
//             </p>
//           ) : (
//             <>
//               {/* Doctor Name */}
//               <h2 className="text-3xl font-bold text-blue-800 flex items-center gap-3">
//                 <User className="w-6 h-6" />
//                 {doctor.doctor_name || (
//                   <span className="text-gray-400">Not Provided</span>
//                 )}
//               </h2>

//               {/* Grid Info */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 text-sm">
//                 <p className="flex items-center gap-2">
//                   <Mail className="w-4 h-4 text-blue-500" />
//                   {doctor.doctor_email || (
//                     <span className="text-gray-400">Not Provided</span>
//                   )}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   <Phone className="w-4 h-4 text-green-500" />
//                   {doctor.phone_no || (
//                     <span className="text-gray-400">Not Provided</span>
//                   )}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   <Hospital className="w-4 h-4 text-purple-500" />
//                   {doctor.clinic_name || (
//                     <span className="text-gray-400">Clinic not specified</span>
//                   )}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   <MapPin className="w-4 h-4 text-pink-500" />
//                   {doctor.address || (
//                     <span className="text-gray-400">No address</span>
//                   )}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   <Shield className="w-4 h-4 text-yellow-500" />
//                   <span>Registration No:</span>{" "}
//                   {doctor.registration_no || "N/A"}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   <Shield className="w-4 h-4 text-red-400" />
//                   <span>Medical License No:</span>{" "}
//                   {doctor.medical_licence_no || "N/A"}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   🎓 <span>Degree:</span> {doctor.degree_name || "N/A"}
//                 </p>

//                 <p className="flex items-center gap-2">
//                   <Clock className="w-4 h-4 text-indigo-500" />
//                   <span>OPD Time:</span> {doctor.opd_time || "N/A"}
//                 </p>
//               </div>

//               {/* UPI QR Section */}
//               {doctor.upi_scan_code && (
//                 <div className="mt-6 text-center">
//                   <p className="font-semibold text-blue-700 mb-2">
//                     Scan to Pay
//                   </p>
//                   <img
//                     src={doctor.upi_scan_code}
//                     alt="UPI Scan Code"
//                     className="mx-auto w-40 h-40 rounded-xl border border-blue-200 shadow-sm"
//                   />
//                 </div>
//               )}

//               {subscription && (
//   <div className="max-w-4xl mx-auto mt-6 px-4">
//     <div className="bg-gradient-to-r from-blue-100 to-blue-50 border border-blue-200 rounded-2xl p-5 shadow-sm">
      
//       <h3 className="text-lg font-bold text-blue-700 mb-3">
//         Subscription Details
//       </h3>

//       <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm text-gray-700">
//         <p>
//           <span className="font-semibold">Plan:</span>{" "}
//           {subscription.plan?.toUpperCase() || "FREE"}
//         </p>

//         <p>
//           <span className="font-semibold">Expiry:</span>{" "}
//           {subscription.expiry_date || "N/A"}
//         </p>

//         <p>
//           <span className="font-semibold">Total:</span>{" "}
//           {subscription.total_credits}
//         </p>

//         <p>
//           <span className="font-semibold">Used:</span>{" "}
//           {subscription.used_credits}
//         </p>

//         <p className="col-span-2 sm:col-span-1">
//           <span className="font-semibold">Remaining:</span>{" "}
//           <span className="text-green-600 font-bold">
//             {subscription.remaining_credits}
//           </span>
//         </p>
//       </div>

//       {/* 🔥 Progress Bar */}
//       <div className="mt-4">
//         <div className="w-full bg-gray-200 rounded-full h-2">
//           <div
//             className="bg-blue-600 h-2 rounded-full transition-all"
//             style={{
//               width: `${
//                 subscription.total_credits
//                   ? (subscription.used_credits /
//                       subscription.total_credits) *
//                     100
//                   : 0
//               }%`,
//             }}
//           ></div>
//         </div>
//       </div>
//     </div>
//   </div>
// )}
// <button
//   onClick={() => navigate("/subscription")}
//   className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700"
// >
//   Upgrade Plan
// </button>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DoctorProfile;


import React, { useState, useEffect, useContext } from "react";
import {
  User,
  Phone,
  Mail,
  MapPin,
  Shield,
  Clock,
  Hospital,
} from "lucide-react";
import Navbar from "../components/Navbar";
import languageContext from "../context/language/languageContext";
import API from "../api";
import { useNavigate } from "react-router-dom";

const DoctorProfile = () => {
  const { setSessionTimeout, setAlert, setMessage } =
    useContext(languageContext);

  const [doctor, setDoctor] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const navigate = useNavigate();

  // =========================
  // 🧠 FETCH DOCTOR
  // =========================
  const getDoctorDetails = async () => {
    try {
      const response = await API.post("/show_profile");

      if (response.status === 200) {
        setDoctor(response.data?.doctor_details || {});
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        console.error("Error:", error.message);
        setAlert(true);
        setMessage("Something went wrong");
      }
    }
  };

  // =========================
  // 💳 FETCH SUBSCRIPTION
  // =========================
  const getSubscription = async () => {
    try {
      const res = await API.post("/subscription"); // ✅ FIXED
      setSubscription(res.data);
      console.log("Subscription data:", res.data); // ✅ DEBUG
    } catch (error) {
      console.error("Subscription error:", error);
    }
  };

const getDaysLeft = (expiryDate) => {
  if (!expiryDate) return 0;

  const expiry = new Date(expiryDate);
  const today = new Date();

  const diff = expiry - today;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

  useEffect(() => {
    getDoctorDetails();
    getSubscription();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-tr from-blue-50 to-white">
      <Navbar />

      <div className="pt-24 px-4 pb-12 max-w-5xl mx-auto space-y-6">
        
        {/* ========================= */}
        {/* 🔥 SUBSCRIPTION CARD */}
        {/* ========================= */}
        {subscription && (
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-2xl p-6">

            {/* Glow */}
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top,_white,_transparent)]"></div>

            {/* Header */}
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm opacity-80">Current Plan</p>
                <h2 className="text-2xl font-bold">
                  {subscription.plan?.toUpperCase() || "FREE"}
                </h2>
              </div>

              <div className="text-right">
                <p className="text-sm opacity-80">Expiry</p>
                <p className="font-semibold">
                  {subscription?.expiry_date
  ? new Date(subscription.expiry_date).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  : "No active plan"}
                </p>
               <span className="text-sm opacity-80">
  ({getDaysLeft(subscription.expiry_date)} days left)
</span>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-white/20 my-5"></div>

            {/* Stats */}
            <div className="grid grid-cols-3 text-center gap-4">
              <div>
                <p className="text-sm opacity-80">Total</p>
                <p className="text-xl font-bold">
                  {subscription.total_credits}
                </p>
              </div>

              <div>
                <p className="text-sm opacity-80">Used</p>
                <p className="text-xl font-bold">
                  {subscription.used_credits}
                </p>
              </div>

              <div>
                <p className="text-sm opacity-80">Remaining</p>
                <p className="text-xl font-bold text-green-300">
                  {subscription.remaining_credits}
                </p>
              </div>
            </div>

            {/* Progress */}
            <div className="mt-6">
              <div className="flex justify-between text-xs mb-1 opacity-80">
                <span>Usage</span>
                <span>
                  {subscription.used_credits}/{subscription.total_credits}
                </span>
              </div>

              <div className="w-full h-3 bg-white/20 rounded-full overflow-hidden">
                <div
                  className="h-full bg-green-400 transition-all duration-500"
                  style={{
                    width: `${
                      subscription.total_credits
                        ? (subscription.used_credits /
                            subscription.total_credits) *
                          100
                        : 0
                    }%`,
                  }}
                ></div>
              </div>
            </div>

            {/* Low Credit Warning */}
            {subscription.remaining_credits < 10 && (
              <p className="text-yellow-200 mt-3 text-sm">
                ⚠️ Low credits — upgrade soon
              </p>
            )}

            {/* CTA */}
            <div className="mt-6 flex justify-end relative z-10">
  <button
    onClick={() => navigate("/subscription")}
    className="bg-white text-blue-600 px-5 py-2 rounded-xl font-semibold shadow hover:scale-105 transition"
  >
    Upgrade Plan 🚀
  </button>
</div>
            
          </div>
        )}

        {/* ========================= */}
        {/* 👨‍⚕️ DOCTOR PROFILE */}
        {/* ========================= */}
        <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 border border-blue-100">
          {!doctor ? (
            <p className="text-center text-gray-500">
              Loading doctor details...
            </p>
          ) : (
            <>
              <h2 className="text-3xl font-bold text-blue-800 flex items-center gap-3 mb-4">
                <User className="w-6 h-6" />
                {doctor.doctor_name || "Not Provided"}
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 text-sm">
                <p className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-blue-500" />
                  {doctor.doctor_email || "Not Provided"}
                </p>

                <p className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-green-500" />
                  {doctor.phone_no || "Not Provided"}
                </p>

                <p className="flex items-center gap-2">
                  <Hospital className="w-4 h-4 text-purple-500" />
                  {doctor.clinic_name || "Not Provided"}
                </p>

                <p className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-pink-500" />
                  {doctor.address || "Not Provided"}
                </p>

                <p className="flex items-center gap-2">
                  <Shield className="w-4 h-4 text-yellow-500" />
                  {doctor.registration_no || "N/A"}
                </p>

                <p className="flex items-center gap-2">
                  <Shield className="w-4 h-4 text-red-400" />
                  {doctor.medical_licence_no || "N/A"}
                </p>

                <p>🎓 {doctor.degree_name || "N/A"}</p>

                <p className="flex items-center gap-2">
                  <Clock className="w-4 h-4 text-indigo-500" />
                  {doctor.opd_time || "N/A"}
                </p>
              </div>

              {/* QR */}
              {doctor.upi_scan_code && (
                <div className="mt-6 text-center">
                  <p className="font-semibold text-blue-700 mb-2">
                    Scan to Pay
                  </p>
                  <img
                    src={doctor.upi_scan_code}
                    alt="QR"
                    className="mx-auto w-40 h-40 rounded-xl border"
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;